module.exports = __webpack_public_path__ + "img/logobottom.eca46cf2.png";